import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router-dom'
import { MyTeamRolesPage } from './MyTeamRolesPage'

export const NotFoundRolesPage = observer(() => {
  const { levelId } = useParams()
  const location = useLocation()
  const levelName = (location.state as { levelName?: string } | null)?.levelName

  if (!levelId) {
    throw new Error('Missing department key')
  }

  if (!levelName) {
    throw new Error('Missing department name')
  }

  return (
    <MyTeamRolesPage levelId={levelId} levelName={levelName} />
  )
})
